module.exports = __webpack_public_path__ + "static/media/B1.c250f598.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B1.png
// module id = 878
// module chunks = 0